const jQ = jQuery.noConflict();
const filterWrapper = jQ('.posts-filters');
const el = jQ('.filter-trigger');
const list = jQ('.filter-items-list');

function closeFilters() {
    el.removeClass('active');
    list.removeClass('show-list').delay(200).queue(() => {
        list.slideUp().dequeue();
    });
}
function openFilters() {
    el.addClass('active');

    list.slideDown().delay(200).queue(() => {
        list.addClass('show-list').dequeue();
    });
}
function triggerClick() {
    if (el.hasClass('active')) {
        closeFilters();
    } else {
        openFilters();
    }
}
function filterTrigger() {
    if (filterWrapper.length > 0) {
        el.on('click', triggerClick);
    }
}

export { filterTrigger, closeFilters };
